import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getBalance, debit, syncBalance } from "../services/WalletService";
import { createOrderRecord } from "../services/OrderService";
import Seo from "../Components/Seo";

export default function OrderConfirm() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [placed, setPlaced] = useState(false);
  const [order, setOrder] = useState(null);
  const [paying, setPaying] = useState(false);
  const [error, setError] = useState("");
  const [balance, setBalance] = useState(() => getBalance());

  // Server se balance sync
  useEffect(() => {
    const mobile = localStorage.getItem("userMobileNumber");
    if (!mobile) return;
    syncBalance(mobile).then((b) => setBalance(b));
    const onUpdate = () => setBalance(getBalance());
    window.addEventListener("wallet:updated", onUpdate);
    return () => window.removeEventListener("wallet:updated", onUpdate);
  }, []);

  const items = Array.isArray(state?.items) ? state.items : [];
  const total = state?.total ?? items.reduce((s, p) => s + (Number(p?.Price ?? p?.price) || 0) * (Number(p?.Quantity ?? p?.quantity) || 1), 0);

  if (!items.length && !placed) {
    return (
      <div style={{ maxWidth: "600px", margin: "40px auto", padding: "24px", textAlign: "center" }}>
        <h3 style={{ color: "#0f172a" }}>Checkout</h3>
        <p style={{ color: "#64748b" }}>Cart khali hai. Pehle cart me products add karein.</p>
        <button onClick={() => navigate("/catalogue")} style={btn1}>Go to Catalogue</button>
      </div>
    );
  }

  const handlePay = async () => {
    setPaying(true);
    setError("");
    const freshBalance = await syncBalance(localStorage.getItem("userMobileNumber"));
    setBalance(freshBalance);
    if (freshBalance < total) {
      setError(`Wallet balance kam hai — ₹${freshBalance}. Pehle Add Money / UPI se wallet top-up karein.`);
      setPaying(false);
      return;
    }
    const result = await debit(total, `Order payment: ${items.length} item(s)`);
    if (!result.success) {
      setError(result.reason === "insufficient-balance" ? "Wallet balance kam hai." : "Payment failed — internet check karke dobara try karein.");
      setPaying(false);
      return;
    }
    const orderId = `AIO${Date.now()}`;
    const o = createOrderRecord({ orderId, items, total, walletBalanceAfter: result.balance });
    setOrder(o);
    setPlaced(true);
    setPaying(false);
  };

  if (placed && order) {
    return (
      <div style={{ maxWidth: "700px", margin: "40px auto", padding: "24px" }}>
        <div style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: "14px", padding: "20px", textAlign: "center" }}>
          <div style={{ fontSize: "44px" }}>✅</div>
          <h2 style={{ color: "#15803d", margin: "8px 0 4px" }}>Order Confirmed!</h2>
          <div style={{ color: "#0f172a", fontWeight: 700 }}>Order ID: {order.orderId}</div>
          <div style={{ color: "#64748b", fontSize: "14px" }}>{order.date} • {order.time}</div>
          <div style={{ color: "#15803d", fontWeight: 800, marginTop: "6px" }}>Paid ₹{total} via Wallet</div>
          <div style={{ color: "#64748b", fontSize: "13px", marginTop: "4px" }}>Wallet balance after: ₹{order.walletBalanceAfter}</div>
        </div>

        <div style={{ background: "#fff", borderRadius: "14px", border: "1px solid #f1f5f9", padding: "16px", marginTop: "16px" }}>
          {order.items.map((it, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f1f5f9" }}>
              <div>
                <div style={{ fontWeight: 600 }}>{it.productName}</div>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Qty: {it.quantity}</div>
              </div>
              <div style={{ fontWeight: 700 }}>₹{(it.price * it.quantity).toFixed(2)}</div>
            </div>
          ))}
          <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", fontWeight: 800, fontSize: "16px" }}>
            <span>Total Paid</span><span>₹{total}</span>
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "16px" }}>
          <button onClick={() => navigate("/")} style={btn1}>Back to Home</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "700px", margin: "40px auto", padding: "24px" }}>
      <Seo title="Checkout & Order Confirmation" description="AIO India checkout — wallet se payment karein aur order confirm karein. Instant order bill ke saath." path="/checkout" />
      <h2 style={{ color: "#0f172a" }}>Checkout</h2>

      <div style={{ background: "#fff", borderRadius: "14px", border: "1px solid #f1f5f9", padding: "16px", marginBottom: "16px" }}>
        {items.map((it, i) => {
          const qty = Number(it?.Quantity ?? it?.quantity) || 1;
          const price = Number(it?.Price ?? it?.price) || 0;
          return (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f1f5f9" }}>
              <div>
                <div style={{ fontWeight: 600 }}>{it?.ProductName ?? it?.name}</div>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Qty: {qty}</div>
              </div>
              <div style={{ fontWeight: 700 }}>₹{(price * qty).toFixed(2)}</div>
            </div>
          );
        })}
        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", fontWeight: 800, fontSize: "17px", color: "#0f172a" }}>
          <span>Total</span><span>₹{total}</span>
        </div>
      </div>

      <div style={{ background: "#fff", borderRadius: "14px", border: "1px solid #f1f5f9", padding: "16px", textAlign: "center", marginBottom: "16px" }}>
        <div style={{ fontWeight: 700, color: "#0f172a" }}>Pay via Wallet</div>
        <div style={{ fontSize: "13px", color: "#64748b", marginTop: "4px" }}>
          Wallet Balance: <strong>₹{balance}</strong>
        </div>
        {error && <div style={{ color: "#dc2626", fontSize: "13px", marginTop: "8px", fontWeight: 600 }}>{error}</div>}
        <button
          onClick={handlePay}
          disabled={paying}
          style={{
            ...btnPrimary,
            opacity: paying ? 0.6 : 1,
            marginTop: "12px",
            background: balance >= total ? "linear-gradient(135deg,#7c3aed,#a855f7)" : "#b0b4c0",
          }}
        >
          {paying ? "Processing..." : `Pay ₹${total} via Wallet`}
        </button>
        <div style={{ marginTop: "8px" }}>
          <button onClick={() => navigate("/wallet")} style={btn3}>Wallet me paise add karein</button>
        </div>
      </div>
    </div>
  );
}

const btn1 = { padding: "10px 24px", borderRadius: "8px", border: "none", background: "#2563eb", color: "#fff", fontWeight: 700, cursor: "pointer" };
const btnPrimary = { padding: "12px 28px", borderRadius: "10px", border: "none", color: "#fff", fontWeight: 700, cursor: "pointer", boxShadow: "0 6px 16px rgba(124,58,237,0.35)" };
const btn3 = { padding: "8px 16px", borderRadius: "8px", border: "1px solid #ddd", background: "#fff", color: "#2563eb", fontWeight: 600, cursor: "pointer" };